import { Injectable } from "@angular/core";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { User } from "@app/core/user/domain/user";
import { UserMapper } from "@app/core/user/data/network/user.mapper";

@Injectable({
  providedIn: "root",
})
export class CompleteProfileWS {
  constructor(private handler: BaseHandler) {}

  execute(params: { profile: User; token: string }) {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.COMPLETE_PROFILE_ENDPOINT())
      .setMethod(HttpMethod.post)
      .setAuthorization(new TokenAuthorization(params.token))
      .setBody(UserMapper.serialize(params.profile))
      .build();
    return this.handler.execute(parameters);
  }
}
